import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
// Models
import { UserModel, UserService } from 'src/app/core/authen';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditProfileComponent implements OnInit {

  @Input() user: UserModel = <UserModel>{};

  profileForm: UntypedFormGroup;
  isHidePass = true;
  isSaving = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private notifier: NotifierService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  /**
   * Create form
   */
  createForm() {
    this.profileForm = this.formBuilder.group({
      first_name: [this.user.fName, Validators.required],
      last_name: [this.user.lName, Validators.required],
      email: [this.user.email, [Validators.required, Validators.email]],
      phone_number: [this.user.phoneNumber, Validators.required],
      company_name: [this.user.company, Validators.required],
      company_address: [this.user.companyAddress, Validators.required],
      password: [''],
    });
  }

  /**
   * is show password to text
   */
  isShow() {
    this.isHidePass = !this.isHidePass;
  }

  /**
   * Prepare form — merge edited fields into the existing user, preserving
   * fields the user must not be able to change themselves (role, id, etc.)
   */
  prepareForm(): UserModel {
    const controls = this.profileForm.controls;
    const _user = new UserModel();
    Object.assign(_user, this.user);

    _user.fName = controls['first_name'].value;
    _user.lName = controls['last_name'].value;
    _user.email = controls['email'].value;
    _user.username = controls['email'].value;
    _user.phoneNumber = controls['phone_number'].value;
    _user.company = controls['company_name'].value;
    _user.companyAddress = controls['company_address'].value;

    const _password = controls['password'].value;
    if (_password) {
      _user.password = _password;
    } else {
      _user.password = this.user.password;
    }

    return _user;
  }

  /**
   * on submit
   */
  onSubmit() {
    if (this.profileForm.invalid || this.isSaving) {
      return;
    }

    const _user = this.prepareForm();
    this.isSaving = true;

    this.userService.updateUser(_user).subscribe({
      next: (res) => {
        this.isSaving = false;
        if (res) {
          this.activeModal.close(_user);
        }
      },
      error: () => {
        this.isSaving = false;
        this.notifier.notify('error', 'บันทึกข้อมูลไม่สำเร็จ');
      },
    });
  }

  /**
   * close dialog
   */
  dismissModal() {
    this.activeModal.dismiss('Cross click');
  }
}
